module.exports = __webpack_public_path__ + "assets/retina_TDropPerpDetailed.08f856c1e0c56df9da56bd0f6f4c32e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_TDropPerpDetailed.png
// module id = 731
// module chunks = 0